export function CatItem({ img }) {
	return (
		<li>
			<img src={img} />
		</li>
	)
}